/* Documentation pages (sections/docs-main.liquid). Loaded by that section only.
   Everything here adds to a page that already reads without it: the menu disclosure on phones, search,
   copy buttons on code, links on headings, keyboard scrolling for wide tables, and the support form's checks. */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---------- navigation: a disclosure on phones, always open on wider screens ---------- */
  function initNav(root) {
    const nav = $('[data-docs-nav]', root);
    if (!nav) return;
    const phone = matchMedia('(max-width: 899px)');
    const sync = () => { nav.open = !phone.matches; };
    sync();
    phone.addEventListener('change', sync);
    const current = $('a[aria-current="page"]', nav);
    const list = $('nav', nav);
    if (current && list && list.scrollHeight > list.clientHeight) {
      list.scrollTop = Math.max(0, current.offsetTop - list.clientHeight / 2);
    }
  }

  /* Copies text and says whether it worked. First the classic way, in the click itself: it also works where the
     page is shown inside another page (a preview, the theme editor, an in-app browser), where browsers refuse the
     clipboard API. Then the clipboard API. */
  function copyText(text) {
    const active = document.activeElement;
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.setAttribute('aria-hidden', 'true');
    area.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0';
    document.body.append(area);
    area.select();
    area.setSelectionRange(0, text.length);
    let ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { /* not allowed */ }
    area.remove();
    if (active && active.focus) active.focus({ preventScroll: true });
    if (ok) return Promise.resolve(true);
    if (!navigator.clipboard) return Promise.resolve(false);
    return navigator.clipboard.writeText(text).then(() => true, () => false);
  }

  /* ---------- the page's text: tables, code, heading links ---------- */
  function initContent(root) {
    const d = root.dataset;
    $$('.docs-content .docs-table', root).forEach((box) => {
      if (box.scrollWidth <= box.clientWidth || box.hasAttribute('tabindex')) return;
      box.tabIndex = 0;
      box.setAttribute('role', 'region');
      box.setAttribute('aria-label', d.table || 'Table');
    });
    $$('.docs-content pre', root).forEach((pre) => {
      if (pre.parentElement.classList.contains('p-docs-code')) return;
      const wrap = document.createElement('div');
      wrap.className = 'p-docs-code';
      pre.replaceWith(wrap);
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = d.copy || 'Copy';
      btn.setAttribute('aria-live', 'polite');
      let timer;
      btn.addEventListener('click', () => {
        copyText(pre.textContent.replace(/\n$/, '')).then((ok) => {
          if (ok) {
            btn.textContent = d.copied || 'Copied';
          } else {
            /* copying isn't allowed here: select the code, so one key press copies it */
            const range = document.createRange();
            range.selectNodeContents(pre);
            const sel = getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
            btn.textContent = d.copySelect || 'Press Ctrl/⌘+C';
          }
          clearTimeout(timer);
          timer = setTimeout(() => { btn.textContent = d.copy || 'Copy'; }, ok ? 1800 : 4000);
        });
      });
      wrap.append(pre, btn);
    });
    $$('.docs-content :is(h2, h3)[id]', root).forEach((h) => {
      if ($('.p-docs-anchor', h)) return;
      const a = document.createElement('a');
      a.className = 'p-docs-anchor';
      a.href = '#' + h.id;
      a.textContent = '#';
      a.setAttribute('aria-label', (d.anchor || 'Link to this section') + ': ' + h.textContent);
      h.append(a);
    });
  }

  /* ---------- search: the index is loaded the first time the box is used ---------- */
  function initSearch(root) {
    const input = $('[data-docs-q]', root);
    const box = $('[data-docs-results]', root);
    if (!input || !box) return;
    const base = root.dataset.root || '';
    let index = null;
    let loading = null;
    const load = () => (loading ||= fetch(root.dataset.index).then((r) => r.json()).then((data) => { index = data; }).catch(() => { loading = null; }));

    const find = (q) => {
      const terms = q.toLowerCase().split(/\s+/).filter((t) => t.length > 1);
      if (!terms.length || !index) return null;
      const out = [];
      for (const p of index) {
        const title = (p.t + ' ' + p.n).toLowerCase();
        p.s.forEach((s, n) => {
          const head = s.h.toLowerCase();
          const text = s.x.toLowerCase();
          let score = 0;
          let own = false;
          for (const t of terms) {
            const inHead = head.includes(t);
            const inText = text.includes(t);
            if (!inHead && !inText && !title.includes(t)) { score = 0; break; }
            if (inHead || inText) own = true;
            score += (inHead ? 6 : 0) + (head.startsWith(t) ? 2 : 0) + (title.includes(t) ? 3 : 0) + (inText ? 1 : 0);
          }
          /* a page whose title matches is listed once (its opening section), not once per section */
          if (score && (own || n === 0)) out.push({ p, s, score: score + (n === 0 ? 1 : 0) });
        });
      }
      return { terms, hits: out.sort((a, b) => b.score - a.score).slice(0, 12) };
    };

    const snippet = (text, terms) => {
      const low = text.toLowerCase();
      let at = -1;
      for (const t of terms) { const i = low.indexOf(t); if (i > -1 && (at < 0 || i < at)) at = i; }
      const from = Math.max(0, at - 60);
      const cut = (from ? '…' : '') + text.slice(from, from + 150).trim() + (text.length > from + 150 ? '…' : '');
      const re = new RegExp('(' + terms.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|') + ')', 'gi');
      return esc(cut).replace(re, '<mark>$1</mark>');
    };

    const show = () => {
      const q = input.value.trim();
      const res = find(q);
      if (!res) { box.hidden = true; box.innerHTML = ''; return; }
      box.innerHTML = res.hits.length
        ? res.hits.map(({ p, s }) => `<a href="${esc(base + p.u + (s.i ? '#' + s.i : ''))}"><b>${esc(p.n)}${s.h ? ` <span>› ${esc(s.h)}</span>` : ''}</b><small>${snippet(s.x, res.terms)}</small></a>`).join('')
        : `<p>${esc((root.dataset.empty || 'No results for “%s”').replace('%s', q))}</p>`;
      box.hidden = false;
    };

    input.addEventListener('focus', () => { load().then(show); });
    input.addEventListener('input', () => { load().then(show); });
    box.setAttribute('aria-live', 'polite');
    const close = () => { box.hidden = true; };
    root.addEventListener('keydown', (e) => {
      const links = $$('a', box);
      const i = links.indexOf(document.activeElement);
      if (e.key === 'Escape' && !box.hidden) { close(); input.focus(); }
      else if (e.key === 'ArrowDown' && !box.hidden && (e.target === input || i > -1)) { e.preventDefault(); (links[i + 1] || links[0])?.focus(); }
      else if (e.key === 'ArrowUp' && i > -1) { e.preventDefault(); (links[i - 1] || input).focus(); }
    });
    document.addEventListener('click', (e) => { if (!e.target.closest('.p-docs-search')) close(); });
    document.addEventListener('keydown', (e) => {
      if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
      if (/^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName) || e.target.isContentEditable) return;
      e.preventDefault();
      input.focus();
    });
  }

  /* ---------- support form: checked here, then handed to the Help Scout Beacon, where the merchant presses Send ---------- */
  const FILE_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp', 'video/mp4', 'video/quicktime'];
  const RULES = {
    name: (v) => v.length >= 2 && v.length <= 100,
    email: (v, input) => v !== '' && input.validity.valid,
    store: (v) => /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,}(\/\S*)?$/i.test(v),
    text: (v) => v.length >= 20,
    files: (v, input) => input.files.length <= 3 && Array.from(input.files).every((f) => f.size <= 10 * 1024 * 1024 && FILE_TYPES.includes(f.type)),
  };

  function initSupport(root) {
    const box = $('[data-support]', root);
    const form = box && $('[data-support-form]', box);
    if (!form || !box.dataset.beacon) return;
    const next = $('[data-support-next]', box);
    const done = $('[data-support-done]', box);
    let ready = false;

    const check = (field) => {
      const input = $('input, textarea', field);
      const help = $('.help', field);
      const ok = RULES[field.dataset.rule](input.value.trim(), input);
      field.classList.toggle('err', !ok);
      input.setAttribute('aria-invalid', String(!ok));
      if (help) {
        help.dataset.hint ??= help.textContent;
        help.textContent = ok ? help.dataset.hint : field.dataset.error;
      }
      return ok;
    };
    const fields = $$('[data-rule]', form);
    fields.forEach((field) => {
      const input = $('input, textarea', field);
      input.addEventListener(input.type === 'file' ? 'change' : 'blur', () => { if (input.value || field.classList.contains('err')) check(field); });
    });

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const bad = fields.filter((field) => !check(field));
      if (bad.length) { $('input, textarea', bad[0]).focus(); return; }
      const value = (name) => form.elements[name].value.trim();
      if (!ready) {
        ready = true;
        if (!window.Beacon) {
          const queue = function (method, options, data) { queue.readyQueue.push({ method, options, data }); };
          queue.readyQueue = [];
          window.Beacon = queue;
          const script = document.createElement('script');
          script.async = true;
          script.src = 'https://beacon-v2.helpscout.net';
          document.head.append(script);
        }
        window.Beacon('init', box.dataset.beacon);
        window.Beacon('config', { display: { style: 'manual' }, docsEnabled: false, messaging: { contactForm: { showName: true, showSubject: true, allowAttachments: true } } });
        window.Beacon('on', 'email-sent', () => {
          form.reset();
          if (next) next.hidden = true;
          if (done) { done.hidden = false; done.scrollIntoView({ block: 'nearest' }); }
        });
      }
      const store = value('store');
      const theme = value('theme');
      window.Beacon('reset');
      window.Beacon('session-data', { 'Store URL': store, Theme: theme, 'Sent from': location.href });
      window.Beacon('prefill', {
        name: value('name'),
        email: value('email'),
        subject: value('subject') || `${theme} theme support`,
        text: `Store URL: ${store}\nTheme: ${theme}\n\n${value('text')}`,
        attachments: Array.from(form.elements.files.files),
      });
      window.Beacon('open');
      window.Beacon('navigate', '/ask/message/');
      if (done) done.hidden = true;
      if (next) next.hidden = false;
    });
  }

  function init() {
    $$('[data-docs]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      initNav(root);
      initContent(root);
      initSearch(root);
      initSupport(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
